<script lang="ts">
	import type { CardItem } from "./ArticleCardProps.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import translations from "./ArticleCard.translations.json";
	import logo from "../../../core/assets/logo-blue.svg";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import DynamicPicture from "./Picture/DynamicPicture.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import Link from "./Link.svelte";
	import { getTranslate } from "../utils/getTranslate.js";

	export let card: CardItem;
	export let labels: string[] = [];
	export let imageInset = false;

	const imageBoxClass = "w-full max-w-[37.5rem] xl:w-[37.5rem]";

	const translate = getTranslate(translations);
</script>

<div
	class="border-lttertiary flex flex-col overflow-hidden border-b bg-white last:border-b-0 xl:flex-row {imageInset
		? 'xl:h-[29rem]'
		: 'xl:h-[25.8125rem]'}"
>
	<a href={card.href} class="block w-full xl:shrink-0 {imageInset ? 'p-4 md:p-8 xl:w-auto' : 'xl:w-[35%]'}">
		{#if card.primaryImage}
			<DynamicPicture
				class={imageInset ? imageBoxClass : "size-full object-cover object-center"}
				imgClass={imageInset
					? "aspect-[3/2] w-full object-cover object-center"
					: "size-full object-cover object-center"}
				alt={card.title}
				image={card.primaryImage}
				width={0}
				height={0}
				bucket="storage"
				sourcesets={imageInset
					? {
							"<md": [720, 0],
							">md": [600, 400],
						}
					: {
							"<md": [720, 0],
							">md": [400, 0],
							">lg": [440, 0],
							">xl": [620, 413],
						}}
			/>
		{:else}
			<div
				class="bg-lttertiary-50 flex items-center justify-center {imageInset
					? `aspect-[3/2] ${imageBoxClass}`
					: 'size-full min-h-[12rem]'}"
			>
				<StaticPicture alt="" image={logo} width={250} height={38} class="m-auto w-40" imgClass="h-auto w-full" />
			</div>
		{/if}
	</a>
	<article class="flex flex-1 flex-col justify-between gap-5 bg-white p-4 md:p-8">
		<div class="flex flex-wrap gap-2">
			{#each labels as label (label)}
				<span
					class="font-bahnschrift text-ltprimary-300 border-lttertiary-100 bg-lttertiary-100 text-2xs/none border p-2 font-normal uppercase tracking-wider"
				>
					{label}
				</span>
			{/each}
		</div>
		<div class="flex flex-col gap-3">
			<div class="font-bahnschrift text-2lg/[1.1] font-light uppercase tracking-normal text-black">
				<a href={card.href} class="text-black">{nbspify(card.title)}</a>
			</div>
			<div class="text-ltsecondary line-clamp-3 text-base/[1.6] font-normal">
				{nbspify(card.perex)}
			</div>
		</div>
		<Link
			aria-label={translate("readMoreAria", {}, true)}
			class="font-roboto text-base/none !font-medium uppercase tracking-wider"
			iconGap="mr-0"
			variant="underline"
			icon={arrowRight}
			href={card.href}>{translate("readMore")}...</Link
		>
	</article>
</div>
